export default __webpack_public_path__ + "static/media/line_vertical_purple.97efe545.svg";